import { useQuery } from 'react-query';
import { getUserOptions } from '../api/getUserOptions';
import { masterDataKeys, masterDataStaleTime } from '../api/queryKeys';

/**
 * Fetch company user options (already parsed via parseUserOptions schema).
 *
 * @param {Object} [params]
 * @param {Object} [options]
 * @param {boolean} [options.enabled=true]
 * @param {(error: unknown) => void} [options.onError]
 */
export const useUserOptions = (params, { enabled = true, onError } = {}) => {
  const { data, isLoading, isError, refetch } = useQuery(
    masterDataKeys.userOptions(params),
    ({ signal }) => getUserOptions(params, signal),
    {
      enabled,
      staleTime: masterDataStaleTime.BATCH,
      onError,
    }
  );

  return { data, isLoading, isError, refetch };
};

export default useUserOptions;
